import React, { useState } from 'react';
import PropTypes from 'prop-types';

const PromoteSiteItem = ({
  site,
  handleDiveSelect,
  handleDiveDeselect,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const itemId = site.site_name.split(' ').join('_').toLowerCase();
  const subscriberCountString = `${site.subscriber_count / 1000}K SUBSCRIBERS`;

  const toggleExpanded = (e) => {
    e.stopPropagation();
    setIsExpanded((prev) => !prev);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleExpanded();
    }
  };

  return (
    <div className={`site-item ${isExpanded ? 'expanded' : ''}`}>
      <div className="site-item__row">
        <div className="site-item__checkbox-col">
          <div className="site-item__checkbox-label">
            <input
              aria-label={`Select ${site.site_name}`}
              className="site-item__checkbox-input"
              type="checkbox"
              onChange={(event) => {
                event.stopPropagation();
                if (!site.primary) {
                  return event.target.checked
                    ? handleDiveSelect(site.site_id)
                    : handleDiveDeselect(site.site_id);
                }
                return null;
              }}
              checked={site.selected}
              disabled={site.primary}
              id={itemId}
            />
            <span className="site-item__checkbox" aria-hidden="true" />
          </div>
        </div>
        <button
          className="site-item__content-col"
          onClick={toggleExpanded}
          onKeyDown={handleKeyDown}
          type="button"
          tabIndex={0}
          style={{ width: '100%', textAlign: 'left' }}
          aria-expanded={isExpanded}
        >
          <div className="site-item__header-row">
            <span className="site-item__name">{site.site_name}</span>
            <span className="site-item__count">{subscriberCountString}</span>
            <svg
              className={`chevron-icon ${isExpanded ? 'rotated' : ''}`}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 13.28 7.59"
              aria-hidden="true"
            >
              <path d="M8,5.25H8l5.16-5a0.34,0.34,0,0,1,.47,0l0.91,0.89a0.32,0.32,0,0,1,0,.45h0L8.24,7.7A0.31,0.31,0,0,1,8,7.79,0.33,0.33,0,0,1,7.75,7.7L1.45,1.65a0.32,0.32,0,0,1,0-.45h0L2.36,0.3a0.34,0.34,0,0,1,.47,0Z" transform="translate(-1.36 -0.21)" />
            </svg>
          </div>
          <div id={`${itemId}-description`} className="site-item__description">
            {site.description}
          </div>
        </button>
      </div>
    </div>
  );
};

PromoteSiteItem.propTypes = {
  site: PropTypes.shape({
    description: PropTypes.string.isRequired,
    site_name: PropTypes.string.isRequired,
    site_domain: PropTypes.string.isRequired,
    site_id: PropTypes.number.isRequired,
    order: PropTypes.number,
    primary: PropTypes.bool.isRequired,
    selected: PropTypes.bool.isRequired,
    subscriber_count: PropTypes.number.isRequired,
  }).isRequired,
  handleDiveSelect: PropTypes.func.isRequired,
  handleDiveDeselect: PropTypes.func.isRequired,
};

export default PromoteSiteItem;
